import { Smartphone } from 'lucide-react';
import { Icon } from '@/shared/components/icons';
import { Banner, Button } from '@/shared/components/ui';
import { useT } from '@/shared/i18n/useT';
import { pwaMsgs } from './messages';
import { useInstallPrompt } from './useInstallPrompt';

export interface InstallBannerProps {
  className?: string;
}

/**
 * Invita a instalar la app. En Chromium abre el diálogo nativo; en Safari de iOS (que no tiene ese
 * diálogo) explica "Compartir → Añadir a inicio". "Ahora no" lo oculta 14 días.
 */
export function InstallBanner({ className }: InstallBannerProps) {
  const { t } = useT(pwaMsgs);
  const { showBanner, canInstall, promptInstall, dismiss } = useInstallPrompt();
  if (!showBanner) return null;

  return (
    <Banner
      tone="info"
      icon={<Icon icon={Smartphone} />}
      title={canInstall ? t('install.title') : t('install.iosTitle')}
      className={className}
      action={
        <div className="flex flex-wrap gap-2">
          {canInstall ? (
            <Button size="sm" onClick={() => void promptInstall()}>
              {t('install.action')}
            </Button>
          ) : null}
          <Button size="sm" variant="ghost" onClick={dismiss}>
            {t('install.dismiss')}
          </Button>
        </div>
      }
    >
      {canInstall ? (
        t('install.body')
      ) : (
        <>
          <p>{t('install.iosIntro')}</p>
          <ol className="mt-1 list-decimal space-y-0.5 pl-5">
            <li>{t('install.iosStep1')}</li>
            <li>{t('install.iosStep2')}</li>
            <li>{t('install.iosStep3')}</li>
          </ol>
        </>
      )}
    </Banner>
  );
}
